import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
  withCredentials: false
});

// Attach token from sessionStorage
instance.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => Promise.reject(error)
);

// Handle 401 — clear token (but don't auto-redirect, let AuthContext handle it)
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Don't clear tokens here — only clear on explicit logout
      // The token might be expired for one API but session is still valid
    }
    return Promise.reject(error);
  }
);

export default instance;
